import styled from 'styled-components';

export const MobileAppAuthFingerprintIconContainerStyled = styled.div`
    margin-bottom: 40px;
    position: relative;
    
    .check-mark-icon {
        position: absolute;
        bottom: -10px;
        right: -10px;
        font-size: 40px;
        fill: var(--color-green-secondary);
    }
`;
